// import { useEffect, useState, useCallback } from "react";

import "./style.scss";
import { isMobileDevice } from "../../common/utilities/platform/platform.util";
import HeaderLayout from "../../components/layout/header-layout.comp";
import FeedbackView from "../admin/feedback/feedback";

const TrialUpgradeView = () => {
    return (
        <HeaderLayout
            subheaderHeight={44}
            subheader={
                isMobileDevice() ? (
                    <div className="header-mobile-trial-upgrade">
                        <span className="header-mobile-trial-upgrade__text">
                            Trial version has expired
                        </span>
                    </div>
                ) : undefined
            }
        >
            <div className="trial-upgrade">
                <div
                    className={`trial-upgrade-content${isMobileDevice() ? " trial-upgrade-content--mobile" : ""}`}
                >
                    <FeedbackView />
                </div>
            </div>
        </HeaderLayout>
    );
};

export default TrialUpgradeView;
